import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const styles = {
  grid: {
    // marginRight: "-15px",
    // marginLeft: "-15px",
    marginRight: "0px",
    marginLeft: "0px",
    width: "auto",
    height: "auto",
    height: "-webkit-fill-available !important",
    display: "flow-root",
    paddingLeft: "4%",
    paddingRight: "4%",
  },
};

const useStyles = makeStyles(styles);

export default function GridContainer(props) {
  const classes = useStyles();
  const { children, className, ...rest } = props;
  return (
    <Grid container {...rest} className={classes.grid + " " + className}>
      {children}
    </Grid>
  );
}

GridContainer.defaultProps = {
  className: "",
};

GridContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
